/**
 * This function should ensure that any code that serves only for type testing is never executed.
 */
export function typetest(): never {
  throw new Error('Type test files should never be executed');
}
